import * as Const from '../constants/actionConstants';

import { Action } from 'redux';
import { SubscriptionPeriod } from 'components/constants';
import SubChangeProduct from '../interfaces/actions/SubChangeProduct';
import SubChangePackage from '../interfaces/actions/SubChangePackage';
import SubChangeDateTo from '../interfaces/actions/SubChangeDateTo';
import SubChangeDateFrom from '../interfaces/actions/SubChangeDateFrom';
import SubDateError from '../interfaces/actions/SubDateError';
import SubChangeTypePayment from '../interfaces/actions/SubChangeTypePayment';
import SubChangeFormStatus from '../interfaces/actions/SubChangeFormStatus';
import SubChangeFieldsArea from '../interfaces/actions/SubChangeFieldsArea';
import SubChangePlanePrice from '../interfaces/actions/SubChangePlanePrice';
import SubChangeSubscriptionPeriod from '../interfaces/actions/SubChangeSubscriptionPeriod';
import SubChangeShouldCreatePayment from '../interfaces/actions/SubChangeShouldCreatePayment';

export const subFormInit = (): Action => {
  return {
    type: Const.SUB_FORM_INIT,
  };
};

export const subChangeProduct = (product: string): SubChangeProduct => {
  return {
    type: Const.SUB_CHANGE_PRODUCT,
    product,
  };
};

export const subChangePackage = (package_: string): SubChangePackage => {
  return {
    type: Const.SUB_CHANGE_PACKAGE,
    package_,
  };
};

export const subChangeDateTo = (dateTo: Date): SubChangeDateTo => {
  return {
    type: Const.SUB_CHANGE_DATE_TO,
    dateTo,
  };
};

export const subChangeDateFrom = (dateFrom: Date): SubChangeDateFrom => {
  return {
    type: Const.SUB_CHANGE_DATE_FROM,
    dateFrom,
  };
};

export const subDateError = (dateError: string): SubDateError => {
  return {
    type: Const.SUB_DATE_ERROR,
    dateError,
  };
};

export const subChangeTypePayment = (typePayment: string): SubChangeTypePayment => {
  return {
    type: Const.SUB_CHANGE_TYPE_PAYMENT,
    typePayment,
  };
};

export const subChangePlanePrice = (planePrice: number | string): SubChangePlanePrice => {
  return {
    type: Const.SUB_CHANGE_PLANE_PRICE,
    planePrice,
  };
};

export const subChangeFieldsArea = (fieldsArea: string): SubChangeFieldsArea => {
  return {
    type: Const.SUB_CHANGE_FIELDS_AREA,
    fieldsArea,
  };
};

export const subChangeSubscriptionPeriod = (period: SubscriptionPeriod): SubChangeSubscriptionPeriod => {
  return {
    type: Const.SUB_CHANGE_SUBSCRIPTION_PERIOD,
    period,
  };
};

export const subChangeShouldCreatePayment = (shouldCreatePayment: boolean): SubChangeShouldCreatePayment => {
  return {
    type: Const.SUB_CHANGE_SHOULD_CREATE_PAYMENT,
    shouldCreatePayment,
  };
};

export const subChangeFormStatus = (formReady: boolean): SubChangeFormStatus => {
  return {
    type: Const.SUB_CHANGE_FORM_READY,
    formReady,
  };
};
